import { render, staticRenderFns } from "./AddUserToCampaign.vue?vue&type=template&id=4e2804f1&scoped=true&"
import script from "./AddUserToCampaign.vue?vue&type=script&lang=js&"
export * from "./AddUserToCampaign.vue?vue&type=script&lang=js&"
import style0 from "./AddUserToCampaign.vue?vue&type=style&index=0&id=4e2804f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2804f1",
  null
  
)

export default component.exports